import api from "@/requests";
import "@/jsdoc/types/calendar"

export const fetchBillsCalendar = () => api.get("/api/v1/Myred/GetCalendar");

/**
 * Детализация календаря 
 * 
 * @param {InvoiceRequest} payload
 * @returns {Promise<string>}
 */
export const fetchInvoices = ({simpleId, billNum, date, type}, options = {}) =>
  api.post("/api/v1/MyRed/BillDetailsForCalendar", {
    redSimpleId: simpleId,
    selectedBillNum: billNum,
    prepaymentBillDate: date,
    requestType: type,
  }, options);
